import { render } from "./ContentPlaceholdersImg.vue?vue&type=template&id=947c3baa"
import script from "./ContentPlaceholdersImg.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholdersImg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__